module.exports = __webpack_public_path__ + "img/coupon_share@2x.478f2317.png";